import React from "react";
import { Flex } from "../../components/Flex";
import { Paragraph, Title } from "../../components/Text";
import { Upload } from "../../components/Upload";
import ShcEmptyIcon from '../../images/shc-empty.svg';


const ShcEmpty = ({ uploadFile }) => {

    return(
        <Flex direction="column" height="100%" align="center" justify="center">
            <img src={ShcEmptyIcon} alt="403" style={{ marginBottom: "48px" }}/>
            <Title h3>No SHC data is available</Title>
            <Flex direction="column" align="center">
                <Flex gap={{ right: 4 }}>
                    <Upload
                        accept=".xml"
                        multiple={true}
                        customRequest={uploadFile}
                    >
                        <Paragraph size="16px" color="var(--sp-main-color)">Upload</Paragraph>
                    </Upload>
                    <Paragraph size="16px">a valid XML file produced by System Health Check</Paragraph>
                </Flex>
                <Paragraph size="16px">on a server running OpenVMS to start working</Paragraph>
                <Paragraph size="16px">with the application</Paragraph>
            </Flex>
        </Flex>
    );
};

export { ShcEmpty };